import { loadLanguageAsync } from '@/locales'

const i18n = {
  state: {
    lang: 'zh-TW',
    userName:localStorage.getItem("userName")
  },
  mutations: {
    SET_LANG: (state, lang) => {
      state.lang = lang
    },
    SET_USER_NAME: (state, userName) => {
      state.userName = userName
    }
  },
  actions: {
    // 设置界面语言
    SetLang ({ commit }, lang) {
      return new Promise(resolve => {
        commit('SET_LANG', lang)
        loadLanguageAsync(lang)
        resolve()
      })
    },
    // 设置界面语言
    setUserName ({ commit }, userName) {
      return new Promise(resolve => {
        commit('SET_USER_NAME', userName)
        localStorage.setItem("userName",userName)
        resolve()
      })
    }
  }
}

export default i18n
